/* eslint-disable max-classes-per-file */

class Queue {
    constructor() {
        this.queue = [];
        this.working_on_promise = false;
    }

    enqueue(promise) {
        return new Promise((resolve, reject) => {
            this.queue.push({
                promise,
                resolve,
                reject,
            });
            this.dequeue();
        });
    }

    dequeue() {
        if (this.working_on_promise) {
            return false;
        }
        const item = this.queue.shift();
        if (!item) {
            return false;
        }
        try {
            this.working_on_promise = true;
            item.promise()
                .then((value) => {
                    this.working_on_promise = false;
                    item.resolve(value);
                    this.dequeue();
                })
                .catch((err) => {
                    this.working_on_promise = false;
                    item.reject(err);
                    this.dequeue();
                });
        } catch (err) {
            this.working_on_promise = false;
            item.reject(err);
            this.dequeue();
        }
        return true;
    }
}

const queue = new Queue();

export default class FeatureToggle {
    constructor(options) {
        if (!options?.user?.token) {
            throw new Error('\'session_token\' parameter is required.');
        }
        this.session_token = options.user.token.startsWith('Bearer ') ? options.user.token.slice(7) : options.user.token;
        this.base_url = options.url || 'https://api.phone.com';

        this.voip_id = options.voip_id;
        this.user_info = {};
    }

    async isFeatureEnabled(feature) {
        const getVoipId = async () => {
            if (this.voip_id) return this.voip_id;
            const url = 'https://api.phone.com/v4/oauth/access-token';
            const headers = {
                'Authorization': `Bearer ${this.session_token}`,
                'Content-Type': 'application/json',
            };
            const res = await fetch(url, {
                method: 'GET',
                headers,
            });
            if (!res.ok) {
                throw new Error('Something went wrong while loading your voip id.');
            }

            const json = await res.json();
            if (json.error) {
                throw new Error('Something went wrong while loading your account data.');
            }
            return (
                json.scope_details?.find((item) => item?.voip_id)?.voip_id
                || json.nxt_details?.voip_id
                || null
            );
        };
        const getUrl = async () => {
            this.voip_id = await getVoipId();
            return `${this.base_url}/v4/accounts/${this.voip_id}/feature-toggles`;
        };
        const getFeatures = async () => {
            if (!this.session_token) {
                throw new Error('\'session_token\' parameter is not available.');
            }
            const key = 'features';
            const cache = this.user_info[key];
            if (cache) return cache;
            const headers = {
                'Authorization': `Bearer ${this.session_token}`,
                'Content-Type': 'application/json',
            };
            const res = await fetch(await getUrl(), {
                method: 'GET',
                headers,
            });
            if (!res.ok) {
                throw new Error('Something went wrong while loading your account data.');
            }

            const json = await res.json();
            if (json.error) {
                throw new Error('Something went wrong while loading your account data.');
            }
            this.user_info[key] = json.items;
            return json;
        };
        let features;
        try {
            features = await queue.enqueue(getFeatures);
        } catch (err) {
            console.log(err);
            throw new Error('Something went wrong while loading your account data.');
        }
        return features && Array.isArray(features) && features.includes(feature);
    }
}
